import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';

/** SEB quitURL target — exam finished or abandoned; safe to leave Safe Exam Browser. */
export default function SebQuit() {
  const [params] = useSearchParams();
  const reason = (params.get('reason') || 'completed').toLowerCase();
  const abandoned = reason === 'abandoned';

  return (
    <div className="hero-glow min-h-screen">
      <div className="mx-auto flex min-h-screen max-w-xl items-center justify-center px-6">
        <Card className="card-elevated w-full">
          <CardContent className="p-8 text-center" data-testid="seb-quit">
            {abandoned ? (
              <>
                <AlertTriangle className="mx-auto h-10 w-10 text-amber-600" />
                <h1 className="mt-3 text-2xl font-semibold">Assessment abandoned</h1>
                <p className="mt-2 text-sm text-muted-foreground">
                  You exited without completing. This attempt is closed and will not be scored.
                  You may close Safe Exam Browser. Contact HR if you need a new invitation.
                </p>
              </>
            ) : (
              <>
                <CheckCircle2 className="mx-auto h-10 w-10 text-emerald-500" />
                <h1 className="mt-3 text-2xl font-semibold">Assessment complete</h1>
                <p className="mt-2 text-sm text-muted-foreground">
                  You may now close Safe Exam Browser. The HR team will be in touch with next steps.
                </p>
              </>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
